import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Grid,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import { ModalHeader } from "../../common/modalHeader";
export default function AppliedCandidateModal({ open, setOpen, modalData }) {
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open === true) {
    } else {
      console.log("close");
    }
  }, [open]);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const labelStyle = {
    fontWeight: 500,
    color: "#01008B",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  const labelStyle1 = {
    fontWeight: 600,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  const valueStyle = {
    fontWeight: 500,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "80%", md: "70%", lg: "50%" },
          overflowY: "auto",
          height: { xs: "80vh", sm: "70vh", md: "72vh", lg: "55vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "15%", md: "20%", lg: "25%" },
          top: "12%",
        }}
      >
        <ModalHeader title="Candidate Information" onClose={setOpen} />

        <Divider sx={{ borderBottom: "1px solid #01008B" }} />
        <DialogContent sx={{ p: 2, mt: 2 }}>
          <Grid container>
            {/* intro */}
            <Grid container spacing={2}>
              {/* LEFT SIDE */}
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "160px 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}> Candidate Name :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.candidateName || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Applied Date:</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.appliedDate || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Job Title :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.jobTitle || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Email Id :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.candidateEmail || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Mobile No :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.candidateMobile || "-"}
                    {modalData?.candidateMobile && (
                      <IconButton
                        size="small"
                        sx={{ p: 0 }}
                        onClick={() =>
                          window.open(
                            `https://web.whatsapp.com/send?phone=${modalData?.candidateMobile}`,
                            "_blank",
                          )
                        }
                      >
                        <WhatsAppIcon
                          sx={{
                            color: "white",
                            fontSize: 20,
                            borderRadius: "50%",
                            backgroundColor: "#25D366",
                            p: "3px",
                          }}
                        />
                      </IconButton>
                    )}
                  </Typography>
                </Box>
              </Grid>

              {/* RIGHT SIDE */}
              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}>City :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.candidateCity || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Designation :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.candidateDesignation || "-"}
                  </Typography>

                  <Typography sx={labelStyle}>Skills :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.skills || "-"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {/* ....Imidiate avalable */}

            <Grid container spacing={2} mt={1} p={0}>
              {/* LEFT SIDE */}
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "minmax(100px, 180px) 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}> Immediate Availabel:</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.isImmediateAvailable === true ? "Yes" : "No"}
                  </Typography>

                  <Typography sx={labelStyle}>Current Salary :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.currentSalary}/per month
                  </Typography>
                </Box>
              </Grid>

              {/* RIGHT SIDE */}
              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "minmax(100px, 180px) 1fr",
                    rowGap: "8px",
                  }}
                >
                  <Typography sx={labelStyle}>
                    Ready to join within :
                  </Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.readyToJoinWithinDays}{" "}
                    {modalData?.readyToJoinWithinDays === "Immediate"
                      ? ""
                      : "Days"}
                  </Typography>

                  <Typography sx={labelStyle}>Expected Salary :</Typography>
                  <Typography sx={valueStyle}>
                    {modalData?.expectedSalary}/per Month
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Box>
    </Modal>
  );
}
